import { Markdown } from "@/components/Markdown";
import { cn } from "@/lib/utils";
import { TONES, toneOf } from "./tone";

export function Callout({ props, body }: { props: Record<string, unknown>; body: string }) {
  const tone = toneOf(props.tone);
  const t = TONES[tone];
  const Icon = t.icon;
  const title = typeof props.title === "string" ? props.title : undefined;

  return (
    <aside className={cn("flex gap-3 rounded-xl border px-4 py-3.5", t.bg, t.border)} data-tone={tone}>
      <Icon className={cn("mt-0.5 size-[18px] shrink-0", t.text)} aria-hidden />
      <div className="min-w-0 flex-1">
        {title && <div className="mb-1 text-[0.95rem] font-semibold leading-snug">{title}</div>}
        {body.trim() ? (
          <Markdown compact>{body}</Markdown>
        ) : !title ? (
          <span className="text-sm text-muted-foreground">(empty callout)</span>
        ) : null}
      </div>
    </aside>
  );
}
